import axios from 'axios'
import Vue from 'vue'

const state = {
    cases: []
}

const getters = {
    getCases: state => state.cases
}

const actions = {
    async fetchCases({ commit }, {id, params}) {
        commit('setCases', [])
        return new Promise((resolve, reject) => {
            axios.get(`/api/case/${id ?? ""}`, {params: params})
                .then((res) => {
                    commit('setCases', res.data.cases)
                    resolve(res.data.totalCases);
                })
                .catch((error) => {
                    commit('setCases', [])
                    reject(error);
                })
        })
    },
    async addCase({ commit }, { caseRecord, caseReportId }) {

        var params = (caseReportId) ? { caseReportId } : {}

        return new Promise((resolve, reject) => {
            axios.post('/api/case', caseRecord, {params: params})
                .then((res) => {
                    commit('setCases', [])
                    resolve(res.data);
                })
                .catch((error) => {
                  reject(error)
                })
        })
    },

    async addCases({ commit }, cases) {
        return new Promise((resolve, reject) => {
            axios.post("/api/case/batch", cases)
                .then((res) => {
                    commit('setCases', [])
                    resolve(res.data.length);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },
    async updateCase({ commit }, caseRecord) {
        return new Promise((resolve, reject) => {
            axios.put('/api/case/', caseRecord)
                .then((res) => {
                    commit('updateCase', res.data);
                    resolve(res.data);
                })
                .catch((error) => {
                    reject(error);
                })
        });
    },
    async patchCases( {commit}, {params, patch} ) {
         return new Promise((resolve, reject) => {
            axios.patch("/api/case", patch, {params: params})
                .then((resp) => {
                    commit('patchCases');
                    resolve(resp.data);
                })
                .catch((error) => {
                    reject(error);
                })
        })
    },
}

const mutations = {
    setCases: (state, cases) => (state.cases = cases),
    updateCase: function (state, caseRecord) {
        var index = state.cases.findIndex((obj => obj.id == caseRecord.id))
        if (index >= 0) {
            Vue.set(state.cases, index, caseRecord)
        }
    },
    patchCases: function(){}
}

export default {
    state,
    actions,
    mutations,
    getters
}